import request from '@/libs/request'

//入库单 列表
export function warehouseInventoryInListApi (data) {
  return request({
    url: `warehouse/warehouseInventoryIn`,
    method: 'get',
    params: data
  })
}

//入库单 详情
export function warehouseInventoryInInfoApi (id) {
  return request({
    url: `warehouse/warehouseInventoryIn/` + id,
    method: 'get'
  })
}


//入库单 编辑/添加
export function warehouseInventoryInSaveApi (data) {
  return request({
    url: `warehouse/warehouseInventoryIn`,
    method: 'post',
    data: data
  })
}

//入库单 删除
export function warehouseInventoryInDelApi (id) {
  return request({
    url: `warehouse/warehouseInventoryIn/` + id,
    method: 'delete'
  })
}

//入库单 审核
export function warehouseInventoryInAuditApi (data) {
  return request({
    url: `warehouse/warehouseInventoryInApi/audit`,
    method: 'post',
    data: data
  })
}

// 入库单 所有
export function warehouseInventoryInAllApi (data) {
  return request({
    url: `warehouse/warehouseInventoryInApi/all`,
    method: 'get',
    params: data
  })
}

// 基地库存存取周期
export function landBaseAverageCycleApi (data = {}) {
  return request({
    url: `warehouse/warehouseInventoryInApi/getLandBaseAverageCycle`,
    method: 'get',
    params: data
  })
}


